import {
    SET_ANNOUNCEMENT,
    SET_CONNECT_LOBBY,
    SET_LOBBY_LIST,
} from '../actions/type'

const initialState = {
    connecting: false,
    lobbyLists: [],
    lobbyRoomID: null,
    announcement: ''
}

const lobby = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOBBY_LIST: {
            const payload = action.payload;
            return { ...state, ...payload };
        }
        case SET_CONNECT_LOBBY: {
            const payload = action.payload;
            return { ...state, ...payload }
        }
        case SET_ANNOUNCEMENT: {
            const payload = action.payload
            return { ...state, ...payload }
        }
        default:
            return state
    }
}

export default lobby